import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/index.vue'
import Order from './views/order.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/search',
            name: 'Home',
            component: Home,
            meta: {
                title: 'Взять машину на прокат > Аренда автомобилей',
            },
        },
        {
            path: '/order/:id',
            name: 'Order',
            component: Order,
            meta: {
                title: 'Взять машину на прокат > Аренда автомобилей',
            },
        },
    ]
})
